<template>
  <div id="pageCareers" class="page-careers">
    <Header :theme-class="headerThemeClass" />
    <SgCareerBoardTemplate v-if="$store.state.locale == 'sg'" />
    <UsCareerTemplate v-if="$store.state.locale == 'us'" />
    <MyCareerTemplate v-if="$store.state.locale == 'my'" />
    <CaCareerTemplate v-if="$store.state.locale == 'ca'" />
    <HkCareerTemplate v-if="$store.state.locale == 'hk'" />
    <AuCareerTemplate v-if="$store.state.locale == 'au'" />
    <UkCareerTemplate v-if="$store.state.locale == 'uk'" />
    <BmsgCareerTemplate v-if="$store.state.locale == 'bmsg'" />
    <BmusCareerTemplate v-if="$store.state.locale == 'bmus'" />
    <JpCareerTemplate v-if="$store.state.locale == 'jp'" />
    <KrCareerTemplate v-if="$store.state.locale == 'kr'" />
    <FrCareerTemplate v-if="$store.state.locale == 'fr'" />

    <BMFooter v-if="$store.state.locale==='bmus'" />
    <UsOnlineWebFooter v-else-if="showNewUsHeader" />
    <Footer v-else />
    <ToolsGroup />
    <CookiesStatement v-if="$store.state.locale != 'hk'" />
  </div>
</template>
<script>

import Header from '@/components/global/FeatureComponents/Header/web';
import Footer from '@/components/global/FeatureComponents/Footer/webNew'
import UsOnlineWebFooter from '@/components/global/FeatureComponents/Footer/UsOnlineWeb'
import BMFooter from '@/components/global/FeatureComponents/BMFooter/web'
// import CookiesAccept from 'components/common/CookiesAccept/index.vue';
import CookiesStatement from 'components/common/CookiesStatement/index.vue';
import ToolsGroup from 'components/common/ToolsGroup/index.vue';
import SgCareerBoardTemplate from 'components/careers/pageTemplates/SgCareerBoardTemplate/index.vue';
import UsCareerTemplate from 'components/careers/pageTemplates/UsCareerTemplate/index.vue';
import MyCareerTemplate from 'components/careers/pageTemplates/MyCareerTemplate/index.vue';
import CaCareerTemplate from 'components/careers/pageTemplates/CaCareerTemplate/index.vue';
import HkCareerTemplate from 'components/careers/pageTemplates/HkCareerTemplate/index.vue';
import AuCareerTemplate from 'components/careers/pageTemplates/AuCareerTemplate/index.vue';
import UkCareerTemplate from 'components/careers/pageTemplates/UkCareerTemplate/index.vue';
import BmsgCareerTemplate from 'components/careers/pageTemplates/BmsgCareerTemplate/index.vue';
import BmusCareerTemplate from 'components/careers/pageTemplates/BmusCareerTemplate/index.vue';
import JpCareerTemplate from 'components/careers/pageTemplates/JpCareerTemplate/index.vue';
import KrCareerTemplate from 'components/careers/pageTemplates/KrCareerTemplate/index.vue';
import FrCareerTemplate from 'components/careers/pageTemplates/FrCareerTemplate/index.vue';

// 节流函数
const throttle = require('lodash/throttle');

export default {
  components: {
    Header,
    Footer,
    // CookiesAccept,
    CookiesStatement,
    ToolsGroup,
    UsCareerTemplate,
    MyCareerTemplate,
    CaCareerTemplate,
    HkCareerTemplate,
    AuCareerTemplate,
    UkCareerTemplate,
    SgCareerBoardTemplate,
    BmsgCareerTemplate,
    BmusCareerTemplate,
    JpCareerTemplate,
    KrCareerTemplate,
    FrCareerTemplate,
    BMFooter,
    UsOnlineWebFooter,
  },
  middleware: 'careers',
  layout: 'simpleLayout',
  // fetch({ store, error }) {
  //   const { locale } = store.state;
  //   if (locale === 'uk') {
  //     // 英国官网跳转到error页面
  //     const params = {
  //       statusCode: 404,
  //     };
  //     error(params);
  //   }
  // },
  data() {
    const initHeaderThemeClass = this.$store.state.locale === 'sg' ? 'skin-transparent' : ''
    return {
      headerStickyStatus: true,
      headerThemeClass: initHeaderThemeClass,
    }
  },
  computed: {
    thinkType() {
      return this.$store.state.thinkType
    },
    schoolCode() {
      return this.$store.state.schoolCode
    },
    isGray() {
      return (process.env.grayType || '').toLowerCase() === 'gray';
    },
    showNewUsHeader() {
      // us mars uk ca jp kr fr
      const schoolList = ['415', '8601', '4401', '103', '8101', '8201', '3301']
      console.log('thinkType is ----', this.thinkType)
      if (this.isGray && schoolList.includes(this.schoolCode) && this.thinkType === 'online') {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.addScrollEvent();
  },
  destroyed() {
    this.removeScrollEvent();
  },
  methods: {
    // 添加滚动事件
    addScrollEvent() {
      window.addEventListener('scroll', this.watchScroll, false);
    },
    // 移除滚动事件
    removeScrollEvent() {
      window.removeEventListener('scroll', this.watchScroll, false);
    },
    // 监听滚动条事件
    watchScroll: throttle(function watchScrollFun() {
      // 获取浏览器滚动条高度
      const { scrollTop } = document.documentElement;
      // 可视窗口高度
      const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // 获取Header高度
      const bannerHeight = document.getElementById('topHeader').offsetHeight;
      // 判断是否小于Banner高度
      if (scrollTop <= viewPortHeight - bannerHeight && this.$store.state.locale === 'sg') {
        this.headerThemeClass = 'skin-transparent';
      } else {
        this.headerThemeClass = '';
      }
    }, 100, { leading: true, trailing: true }),
  },
}
</script>
